import { setGridValue } from 'js/bubbleCore/utils/setGridValue';
import { loopGrid } from 'js/bubbleCore/utils/loopGrid';
import { IHexGridData } from 'js/bubbleCore/types';
import { Bubble } from 'js/bubbleCore/bubbles/types';
import { removeFromGrid } from 'js/bubbleCore/utils/removeFromGrid';
import { IEvent, createBubbleUpdatedEvent } from 'js/bubbleCore/events';

export function moveGridBubblesDown(grid: IHexGridData<Bubble>, offset: number, events: IEvent[]): void {
  const bubbles: Bubble[] = [];

  loopGrid(grid, (bubble, col, row) => {
    bubbles.push(bubble);
    removeFromGrid(grid, col, row);
  });

  bubbles.forEach((bubble) => {
    bubble.row += offset;
    setGridValue(grid, bubble.col, bubble.row, bubble);
    events.push(createBubbleUpdatedEvent(bubble));
  });
}